import React from 'react'
import { useFormContext } from 'react-hook-form'
import AccountForm from '../../types/account-form.types'
import { Lang } from '../../types/common-types'
import { State } from '../../state-actions-reducers'
import cn from 'classnames'
import styles from './AcceptConditions.module.scss'
import InfoMessage from '../../shared/InfoMessage/InfoMessage'

export enum AvailableClient_Enum {
  None = 0,
  Individual = 1,
  Company = 2,
  Ip = 4,
}

interface Props {
  lang: Lang
  parentUrl: string
  accountForm: AccountForm
  activeForm: 'Physical' | 'Company' | 'Individual'
  changeActiveForm: (e: 'Physical' | 'Company' | 'Individual') => void
  availableClient?: AvailableClient_Enum
}

export default function AcceptConditions({
  lang,
  parentUrl,
  accountForm,
  availableClient,
  activeForm,
  changeActiveForm
}: Props) {
  const { watch, setValue } = useFormContext<State>()
  const state = watch()

  // Фильтруем доступные типы форм на основе availableClient
  const getAvailableFormTypes = (): ("Physical" | "Company" | "Individual")[] => {
    const availableTypes: ("Physical" | "Company" | "Individual")[] = [];
    
    // Проверяем каждый тип через битовую маску
    if ((availableClient! & AvailableClient_Enum.Individual) !== 0) {
      availableTypes.push('Physical');
    }
    
    if ((availableClient! & AvailableClient_Enum.Company) !== 0) {
      availableTypes.push('Company');
    }
    
    if ((availableClient! & AvailableClient_Enum.Ip) !== 0) {
      availableTypes.push('Individual');
    }
    
    return availableTypes;
  };

  const formTypes = getAvailableFormTypes();

  // Если нет доступных типов, показываем сообщение
  if (formTypes.length === 0) {
    return (
      <div className="row">
        <div className="col-12 col-xs-12">
          <InfoMessage 
            text="В данный момент нет доступных типов анкет для заполнения." 
          />
        </div>
      </div>
    );
  }

  // Если активная форма не входит в доступные, выбираем первую доступную
  React.useEffect(() => {
    if (!formTypes.includes(activeForm) && formTypes.length > 0) {
      changeActiveForm(formTypes[0]);
    }
  }, [formTypes, activeForm, changeActiveForm]);

  return (
    <div className="row">
      <div className="col-12 col-xs-12">
        <div className={styles.tabs}>
          {formTypes.map((e) => {
            return (
              <div 
                key={e}
                onClick={() => changeActiveForm(e)} 
                className={cn(styles.tabs_item, activeForm === e && styles.active)}
              >
                {e === 'Physical' ? accountForm.profileType_PhysicalButton[lang] :
                  e === 'Company' ? accountForm.profileType_FiscalButton[lang] :
                  e === "Individual" ? accountForm.profileType_FiscalIPButton[lang] : null
                }
              </div>
            )
          })}
        </div>
      </div>
      <InfoMessage type={'default'} text={<div className={styles.agreementContainer}>
        <span>{accountForm.agreementShowBtnTipText[lang]} </span>
        <a target='_blank' href={`${parentUrl}info/client-form/documents`}>{accountForm.agreementShowBtnTip[lang]}</a>
      </div>} />
      <div className={styles.cheklist}>
        <label className={styles.cheklist_item}>
          <input
            type="checkbox"
            required
            checked={state.agreedCheck}
            onChange={e => setValue('agreedCheck', e.target.checked)}
          />
          <span>{accountForm.agreementButtonConfurmLabel1[lang]} <a target='_blank' href={`${parentUrl}info/client-form/documents`}>{accountForm.agreementButtonConfurmLabel2[lang]}</a></span>
        </label>
        <label className={styles.cheklist_item}>
          <input
            type="checkbox"
            checked={state.subscribe}
            onChange={e => setValue('subscribe', e.target.checked)}
          />
          <span>{accountForm.agreementButtonConfurmLabel3[lang]} 7813216143</span>
        </label>
      </div>
    </div>
  )
}